import "@/App.css";
import { useState } from "react";
import WakeExperience from "./components/WakeExperience";
import IntroSequence from "./components/IntroSequence";

function App() {
  const [showIntro, setShowIntro] = useState(true);

  return (
    <div className="App">
      {showIntro ? (
        <IntroSequence onComplete={() => setShowIntro(false)} />
      ) : (
        <WakeExperience />
      )}
    </div>
  );
}

export default App;
